import { Tag, type TagIntent } from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import {
  type CompensationVariantPayment,
  CompensationVariantPaymentState,
} from '@omnipresentgroup/types';

const getIntentByState = (
  state: CompensationVariantPaymentState,
): TagIntent => {
  switch (state) {
    case CompensationVariantPaymentState.REQUESTED: {
      return 'info';
    }
    case CompensationVariantPaymentState.ACTIVE: {
      return 'success';
    }
    case CompensationVariantPaymentState.INACTIVE:
    case CompensationVariantPaymentState.ARCHIVED: {
      return 'default';
    }
    default: {
      return 'default';
    }
  }
};

export const VariantPaymentState = ({
  variantPayment,
}: {
  variantPayment: CompensationVariantPayment;
}) => {
  const { state } = variantPayment;

  return (
    <Tag id={state} intent={getIntentByState(state)}>
      {toSentenceCase(state)}
    </Tag>
  );
};
